export default __webpack_public_path__ + "static/sam-with-rocket-and-gus-2d75549c7e0d1d08c7f11c82d8f01571.jpg";